<template>
  <CompanyList/>
</template>

<script>
import CompanyList from '@/components/Companies/CompanyList.vue';

export default {
  components: {
    CompanyList,
  },
};
</script>
